module.exports = __webpack_public_path__ + "static/img/rectangle05.1a2942b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/rectangle/rectangle05.jpg
// module id = fSKs
// module chunks = 0